<template>
    <div class="save_share_pic_wrap" :class="{ show: gamePic != '' }">
        <div class="img_box">
            <a
                href="javascript:void(0)"
                class="btn_close"
                @click="closeSharePic"
            ></a>
            <img :src="$store.state.gamePic" alt="" class="share_pic" />
        </div>
        <p class="tips">{{ $t('msg.pressimg2savepicture') }}</p>
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { Bus } from '@/utils/eventBus.js';
export default {
    name: 'saveSharePic',
    props: {
        // 是否显示
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        lang() {
            return this.$store.state.lang;
        },
        gamePic() {
            return this.$store.state.gamePic;
        }
    },
    methods: {
        ...mapMutations(['SET_STATE', 'SHOW_POPUP', 'SET_LANG']),
        ...mapActions(['uploadImg']),
        eventBusDemo() {
            Bus.$emit('_eventBusDemo');
        },
        // 关闭分享图片弹窗
        closeSharePic() {
            this.SET_STATE({
                key: 'gamePic',
                val: ''
            });
        }
    },
    mounted() {}
};
</script>

<style lang="less" scoped>
.save_share_pic_wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    z-index: -1;
    display: none;

    &.show {
        z-index: 5;
        display: flex;
    }

    .img_box {
        position: relative;
        width: 70%;
        min-height: 600px;

        .btn_close {
            position: absolute;
            width: 69px;
            height: 69px;
            background: url(~@/assets/img/lottery_cls.png) top center/100% auto
                no-repeat;
            right: -78px;
            top: 0;
        }

        .share_pic {
            display: block;
            width: 100%;
        }
    }

    .tips {
        position: absolute;
        width: 100%;
        height: 80px;
        line-height: 80px;
        font-size: 24px;
        color: #fff;
        top: 0;
        left: 0;
        text-align: center;
    }
}
</style>
